import { createAction, union, props } from '@ngrx/store';

import { BookingLocationCodes } from '@fcom/common/interfaces/booking';

import { BookingRef } from '../../interfaces/upgrades.interface';
import { GetOffersV2Response } from '../../api/models';

export const setBookingRef = createAction('[Auth] setBookingRef', props<BookingRef>());

export const loadPNR = createAction('[Auth] LoadPNR');

export const setUpgradeData = createAction('[Auth] setUpgradeData', props<Required<GetOffersV2Response>>());

export const flightSummary = createAction('[Auth] Set Flight Summary', props<{ summary: BookingLocationCodes[] }>());

export const logout = createAction('[Auth] Clear Data');

export const setLoggedIn = createAction(
  '[Auth] Set User Logged In Status',
  props<{
    loggedIn: boolean;
  }>()
);

const all = union({
  setBookingRef,
  loadPNR,
  setUpgradeData,
  logout,
  flightSummary,
  setLoggedIn,
});
export type AuthActionsUnion = typeof all;
